"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterChildrenOut = exports.filterChildrenIn = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Filters in the components that match the given componentType
 * @param children - React components children to be filterd
 * @param componentType - The React component type to filter on eg (<Foo />).type
 * @returns Array containing the filtered React component children
 */
var filterChildrenIn = function (children, componentType) {
    return react_1.default.Children.map(children, function (child) {
        if (child && child.type === componentType) {
            return child;
        }
        return null;
    });
};
exports.filterChildrenIn = filterChildrenIn;
/**
 * Filters out the components that match the given component type
 * @param children - React components children to be filterd
 * @param componentType - The React component type to filter on eg (<Foo />).type
 * @returns Array containing the filtered React component children
 */
var filterChildrenOut = function (children, componentType) {
    return react_1.default.Children.map(children, function (child) {
        if (child && child.type !== componentType) {
            return child;
        }
        return null;
    });
};
exports.filterChildrenOut = filterChildrenOut;
